import Link from 'next/link'
import cx from 'classnames'
import urls from 'utilities/urls'
import kickoffLogoLight from 'images/kickoff-logo-light.svg'
import { getFormattedYear } from 'utilities/dates'

import s from './styles.module.css'
import Image from 'next/legacy/image'
import Instagram from './instagram'
import Facebook from './facebook'
import Twitter from './twitter'

const SocialIcons = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
}

interface FooterProps {
  items?: any
  variant?: string
}

export default function Footer({ items = {} }: FooterProps) {
  const year = getFormattedYear()
  const firstCol = items.fields.links.slice(0, 6)
  const secondCol = items.fields.links.slice(6, items.fields.links.length)

  return (
    <footer className={cx(s.footer)}>
      <div className={cx(s.footerWrapper)}>
        <div className={cx(s.footerContent)}>
          <Link {...urls.homePage()} className={cx(s.logoWrapper)}>
            <Image
              src={kickoffLogoLight}
              alt="Kickoff"
              layout="fill"
              objectFit="contain"
            />
          </Link>
          <div className={s.linksWrapper}>
            <div className={s.links}>
              {firstCol.map(({ fields }, i) => {
                return (
                  <a key={`links-${i}`} className={s.link} href={fields.url}>
                    {fields.text}
                  </a>
                )
              })}
            </div>
            <div className={s.links}>
              {secondCol.map(({ fields }, i) => {
                return (
                  <a key={`links-${i}`} className={s.link} href={fields.url}>
                    {fields.text}
                  </a>
                )
              })}
            </div>
            <div className={s.emailSocial}>
              <a className={s.link} href={`mailto:${items.fields.email}`}>
                {items.fields.email}
              </a>
              <div>
                {items.fields.socialLinks.map(({ fields }, i) => {
                  const SocialIcon = SocialIcons[fields.text.toLowerCase()]
                  return (
                    <a
                      key={`social-links-${i}`}
                      aria-label={fields.text.toLowerCase()}
                      id={`${fields.text.toLowerCase()}-share`}
                      className={s.socialLink}
                      href={fields.url}>
                      <SocialIcon />
                    </a>
                  )
                })}
              </div>
            </div>
          </div>
          <div className={s.borderWrapper}>
            <div className={s.border}></div>
          </div>
          <div className={cx(s.terms)}>
            <span>© {year} EverFit Inc. D/B/A Kickoff.</span>
            <a href="https://www.trainwithkickoff.com/terms">
              Terms of Service
            </a>
            <a href="https://www.trainwithkickoff.com/policy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
